import { render } from "./PublicInvitation.vue?vue&type=template&id=40d04012"
import script from "./PublicInvitation.vue?vue&type=script&lang=js"
export * from "./PublicInvitation.vue?vue&type=script&lang=js"

import "./PublicInvitation.vue?vue&type=style&index=0&id=40d04012&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__